module.exports = __webpack_public_path__ + "img/2723.7c787c71.jpg";